import React from 'react';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 60, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1 },
};

const Royaltxt = () => {
  return (
    <motion.section
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      transition={{ duration: 1.2 }}
      viewport={{ once: false, amount: 0.3 }}
      className="bg-white py-12 px-4 sm:py-16 sm:px-6 md:py-20 lg:py-24 font-sans"
    >
      <div className="max-w-xs mx-auto text-center sm:max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-5xl">
        {/* Styled Heading */}
        <div className="mb-8">
          <h2 className="text-xl text-gray-800 font-normal" style={{ fontSize: '32px' }}>
            The Royal Desert Ride
          </h2>
        </div>

        {/* Paragraph */}
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed" style={{ fontSize: '16px' }}>
          A soul-stirring journey through Marwar's sacred dunes, ancient temples, and regal palaces—this experience takes you deep into Rajasthan's warrior heartland. Guided by the noble Marwari horses and steeped in centuries-old trails, the ride invites you to witness the rhythm of life in the desert.
          <br />
          Choose between 5 to 12-day itineraries, each offering a unique blend of historic routes, festival celebrations, and immersive landscapes. Whether you're riding fort-to-fort or joining us during vibrant events like Pushkar or Holi, you'll rest each night in a mix of luxury desert camps and warm village homestays, embraced by Rajasthani hospitality.
        </p>
      </div>
    </motion.section>
  );
};

export default Royaltxt;
